<template>
  <div>
    <scroll-fixed-header :fixed.sync="fixed" :threshold="30">
      <div class="shane_tm_topbar">
        <div class="topbar_inner">
          
          <div class="header-name">
            Katherine Pacitti
          </div>
          <!-- <div class="phone_number">
            <a href="tel:904-549-9245">904-549-9245</a>
          </div>
          <div class="logo">
            <router-link to="/">
              <img class="header_logo" src="../assets/img/logo/logo.png" alt="partners brand" />
            </router-link>
          </div> -->
          <!-- End logo -->
          <div class="menu">
            <scrollactive
              class="anchor_nav"
              bezier-easing-value=".5,0,.35,1"
              :offset="95"
              :duration="100"
              :alwaysTrack="true"
            >
              <div style="display: flex;">
                <div style="margin-right: 20px !important;">
                  <a href="#about" class="scrollactive-item">About</a>
                  <a href="#experience" class="scrollactive-item">Experience</a>
                  <!-- <a href="#about" class="scrollactive-item">About</a> -->
                  <a href="#education" class="scrollactive-item">Education</a>
                  <a href="#personal" class="scrollactive-item">Personal Projects</a>
                  <!-- <a href="#contact" class="scrollactive-item">Writing Samples</a> -->
                  <a href="#resume" class="scrollactive-item">Resume</a>
                </div>
                <!-- <router-link
                  class="white-fill-bg btn-outline btn_sm header_inv_button"
                  to="/inventory"
                >
                  Inventory
                </router-link> -->
              </div>
              <div style="height: 5px; width: 1px;"></div>
            </scrollactive>
          </div>
          <!-- End menu -->
        </div>
      </div>
      <!--  End shane_tm_topbar -->
    </scroll-fixed-header>

    <!-- Start shane mobile menu -->
    <div class="shane_tm_mobile_menu" :class="{isInInventory: isInventory}">
      <div class="topbar_inner">
        
        <div class="container bigger">
          <div class="topbar_in">
            <div class="header-name">
              Katherine Pacitti
            </div>
            <!-- End logo -->
            <div class="my_trigger">
              <div
                class="hamburger hamburger--collapse-r"
                :class="{ 'is-active': active }"
              >
                <div
                  class="hamburger-box"
                  @click="active = !active"
                  :aria-pressed="active ? 'true' : 'false'"
                >
                  <div class="hamburger-inner"></div>
                </div>
              </div>
              <!-- End hamburger menu -->
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown" :class="{ active: active }">
        <div class="container">
          <span
            class="close_menu"
            @click="active = !active"
            :aria-pressed="active ? 'true' : 'false'"
          >
            close
          </span>
          <div class="dropdown_inner">
            <ul class="anchor_nav">
              <li class="current">
                <a href="#about" @click="active = !active">
                  About
                </a>
              </li>
              <li>
                <a href="#experience" @click="active = !active">
                  Experience
                </a>
              </li>
              <li>
                <a href="#education" @click="active = !active">
                  Education
                </a>
              </li>
              <li>
                <a href="#personal" @click="active = !active">
                  Personal Projects
                </a>
              </li>
              <li>
                <a href="#resume" @click="active = !active">
                  Resume
                </a>
              </li>
            </ul>
            <div class="social-menu" style="color:white; text-align: center;">
              katgpacitti@gmail.com
              <br/>
              <div style="margin-top: 10px;">(941) 779-7253</div>
            </div>
            <!-- End social share -->
          </div>
        </div>
        <!-- End container -->
      </div>
    </div>
    <!-- End shane mobile menu -->
  </div>
</template>

<script>
import Social from "../components/SocialTwo.vue";
export default {
  components: {
    Social,
  },
  data() {
    return {
      active: false,
      fixed: false,
      showingMainNav: true,

    };
  },
  watch: {
    isInventory(i) {
      const t = this
      if (!i) {
        setTimeout(() => {
          t.showingMainNav = true
        }, 600)
      } else {
        t.showingMainNav = false
      }
    },
  },
  computed: {
    isInventory() {
      return this.$route.fullPath == '/inventory'
    },
  },
  mounted() {
    this.showingMainNav = !this.isInventory
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css">

.my_trigger {
  padding: 12px;
  padding-bottom: 15px;
  padding-right: 8px;
  padding-top: 16px;
  background: #ffffff;
  transform: translate(-3px, -24px);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 4px 13px #00000017;
}

.header-name {
  font-size: 16px;
  opacity: 0;
}
.phone_number {
  position: absolute;
  transition: all .4s ease;
  z-index: 10;
}
.phone_number a {
  font-weight: bold;
  /* color: black; */
  text-decoration: none;
  padding: 5px;
  color: white;
  background: #f47020;
  border-radius: 10px;
  padding-left: 10px;
  transition: all .5s ease;
}

.shane_tm_mobile_menu {
  position: fixed;
}

.shane_tm_mobile_menu .phone_number {
  margin-left: 75px;
}
.shane_tm_mobile_menu .phone_number a{
  font-size: 12px;
}
.is-fixed .phone_number {
  margin-left: 65px;
}
.is-fixed .phone_number a {
  background: white;
  color: #222;
}

@media screen and (min-width: 768px) {
  .shane_tm_mobile_menu .phone_number {
    margin-left: 98px;
  }
}

.scroll-fixed-header .header_logo {
  transition: opacity .5s ease;
  opacity: 0;
  height: 63px;
  position: absolute;
  top: 6px;
}
.header_logo.small {
  height: 50px;
  position: absolute;
  top: -10px;
}
.scroll-fixed-header.is-fixed .header_logo {
  opacity: 1;
}
.inventory_title {
  position: absolute;
  top: 23px;
  margin-left: 70px;
  color: #363636;
}

.white-fill-bg.btn_sm.header_inv_button {
  border-color: white !important;
}
.header_inv_button {
  transition: all .2s ease !important;
  text-transform: none !important;
  background: white !important;
  color: #262626 !important;
  border: 2px solid white;
  border-color: white !important;
  /* border-color: #343434 !important; */
  position: absolute !important;
  right: 40px;
  vertical-align: baseline !important;
  margin-top: -6px !important;
}
.is-fixed .white-fill-bg.btn_sm.header_inv_button {
  border-color: #343434 !important;
}
</style>